import React from "react";

import SidebarItem from "./SidebarItem";
import { GalleryVerticalEnd } from "lucide-react";
import MiniSidebarSection from "./MiniSidebarSection";

interface SidebarDecksButtonProps {
  isMiniMode: boolean;
}

const SidebarDecksButton: React.FC<SidebarDecksButtonProps> = ({
  isMiniMode,
}) => {
  if (isMiniMode) {
    return (
      <MiniSidebarSection
        icon={<GalleryVerticalEnd size={20} />}
        label="Deck Builder"
        isActive={false}
      />
    );
  }

  return (
    <div id="sidebar-decks-button">
      <SidebarItem
        icon={
          <GalleryVerticalEnd size={20} color="var(--sidebar-item-color)" />
        }
        label="Deck Builder"
        isExpanded={false}
        onToggle={() => {}}
        isActive={false}
        beta={true}
      />
    </div>
  );
};

export default SidebarDecksButton;
